<template>
  <div class="main_wrap">
    <Navigator :routeList="navigate" />
    <div class="topic_detail">
      <div class="topic_cover">
        <el-image
          :src="topicInfo.coverImgUrls || defaultCover"
          class="topic_cover_img"
          fit="cover"
        />
      </div>
      <div class="topic_info">
        <div>
          <div class="topic_title">
            <img src="~@/assets/images/topic_tag.png" class="topic_tag" />
            <div>{{ topicInfo.topicName }}</div>
          </div>
          <div class="topic_intro">
            {{ topicInfo.intro }}
          </div>
        </div>
        <div class="topic_time">
          <span class="topic_time_item">
            <img src="~@/assets/icons/icon_time.png" class="topic_time_icon" />
            {{ getTopicTime }}
          </span>

          <span class="topic_time_item">
            <img
              src="~@/assets/icons/icon_course.png"
              class="topic_time_icon"
            />
            共{{ courseCount }}门课程
          </span>
        </div>
      </div>
    </div>
    <div class="tool_bar">
      <div v-if="isSearchMod" class="count_text">
        符合搜索条件的课程共有{{ total }}门
      </div>
      <div v-else class="count_text">学校已上架该专题内的{{ total }}门课程</div>
      <div class="search">
        <el-input
          class="input search_input"
          placeholder="请输入课程名称"
          clearable
          @clear="getListInfo()"
          @keyup.enter.native="getListInfo()"
          @input="keywordsChange"
          v-model="keywords"
        >
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="getListInfo()"
          />
        </el-input>
      </div>
    </div>
    <LoadingList class="loading_list" :listLenth="12" v-if="loadingHandle" />
    <div v-else class="main_list_wrap">
      <div class="main_list" v-if="courseList.length > 0">
        <a
          class="course_item"
          v-for="(item, index) in courseList"
          :key="index"
          href="#"
          @click.prevent="jumpTo(item)"
        >
          <div class="course_cover_wrap">
            <el-image
              class="course_cover"
              :src="getcovers(item.webSmallCoverImgUrls)"
              fit="cover"
            >
              <div class="error_img" slot="error" />
            </el-image>
            <Tag
              class="course_tag"
              :text="rangeType(item)"
              color="#FFFFFF"
              background="rgba(0,0,0,0.6)"
              no-radius="bottom-left"
            />
          </div>
          <div class="course_info">
            <div class="course_title">
              {{ item.name }}
            </div>
            <div class="course_intro">
              <div class="course_type">
                分类：{{
                  item.courseTypeName || item.provinceCourseTypeName
                }}
              </div>
              <div class="course_grade">
                年级：{{ getGrade(item.courseGradeTermList) }}
              </div>
            </div>
          </div>
        </a>
      </div>
      <Empty v-else height="40rem" />
      <el-pagination
        background
        class="page_nav"
        layout="prev, pager, next"
        :page-size="12"
        v-if="total > 12"
        @current-change="pageChange"
        :current-page="pageNo"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import Tag from "@/components/tag";
import Empty from "@/components/empty.vue";
import LoadingList from "@/components/loadingList.vue";
import { getGrade, setQueryString } from "@/utils/common";
import { getTopicCourseList } from "@/api/course";
import defaultCover from "@/assets/images/default_cover.png";
import Navigator from "@/components/navigate.vue";
@Component({
  components: {
    Tag,
    LoadingList,
    Empty,
    Navigator,
  },
})
export default class CourseListPage extends Vue {
  topicId = null;
  topicInfo = {};
  defaultCover = defaultCover;
  courseCount = 0;

  courseList = [];
  keywords = "";
  gradeList = [];
  grade = null;
  typeList = [];
  type = null;

  isSearchMod = false;

  pageNo = 1;
  pageSize = 12;
  total = 0;

  loadingHandle = false;
  navigate = [];

  activated() {
    const { id } = this.$route.params;
    if (id != this.topicId) {
      this.topicId = id;
      this.keywords = "";
      this.type = null;
      this.refreshList();
      this.getTopicInfo();
    }
    const { from, title, count } = this.$route.query;
    this.courseCount = count;
    if (from == "1") {
      this.navigate = [
        { name: "首页", url: "/course" },
        { name: decodeURIComponent(title), isCurrent: true },
      ];
    } else {
      this.navigate = [
        { name: "首页", url: "/course" },
        { name: "专题资源", url: "/course/topic" },
        { name: decodeURIComponent(title), isCurrent: true },
      ];
    }
  }

  rangeType(item) {
    if (item.courseTypeName) {
      return item.provinceCourseTypeName;
    } else {
      return "省级课程";
    }
  }

  get initType() {
    const { type } = this.$route.params;
    return type;
  }

  get topicName() {
    const { name } = this.$route.query;
    return decodeURIComponent(name);
  }

  get loginStatus() {
    return this.$store.state.AuthModule.loginStatus;
  }

  get getTopicTime() {
    if (this.topicInfo) {
      let date = (this.topicInfo.updateTime || this.topicInfo.createTime)
        ?.split(" ")[0]
        .trim();
      return (date || "") + (this.topicInfo?.updateTime ? "更新" : "创建");
    } else return "-";
  }

  refreshList() {
    this.pageNo = 1;
    this.getListInfo();
  }

  keywordsChange() {
    if (this.keywords.length == 0) {
      this.getListInfo();
    }
  }

  getGrade(grades) {
    const gradeArr = grades.map((item) => {
      return item.grade;
    });
    return getGrade(gradeArr);
  }

  getTopicInfo() {
    const topicStore = JSON.parse(
      window.sessionStorage.getItem("topicStore") || "{}"
    );
    this.topicInfo = topicStore[this.topicId];
  }

  jumpTo(item) {
    const params = {
      ...this.$route.query,
      topicId: this.topicId,
      from: "3",
    };
    if (item.teachingAuxiliaryId) {
      params.teachingAuxiliaryId = item.teachingAuxiliaryId;
      this.$router.push(
        setQueryString(`/course/subjectDetail/${item.id}`, params)
      );
    } else {
      this.$router.push(setQueryString(`/course/detail/${item.id}`, params));
    }
  }

  getcovers(covers) {
    if (covers.length > 0) return covers[0];
    else return "";
  }

  getListInfo() {
    const params = {
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      name: this.keywords || "",
      courseType: this.type || "",
      grade: this.grade || "",
      topicId: this.topicId,
    };
    this.loadingHandle = true;
    getTopicCourseList(params)
      .then((data) => {
        this.courseList = data.records;
        this.total = parseInt(data.total);
        this.isSearchMod = !!this.keywords;
      })
      .finally(() => {
        this.loadingHandle = false;
      });
  }
  pageChange(ev) {
    this.pageNo = ev;
    this.getListInfo();
  }
  back() {
    this.$router.back();
  }
}
</script>
<style lang="less" scoped>
.main_wrap {
  color: #666666;
}
.topic_detail {
  margin: 2rem auto;
  background: #ffffff;
  display: flex;
  padding: 1.5rem 2rem;
  border-radius: 4px;
  .topic_cover {
    width: 31rem;
    height: 17.5rem;
    border-radius: 4px;
    overflow: hidden;
    .topic_cover_img {
      width: 100%;
      height: 100%;
    }
  }
  .topic_info {
    flex: 1;
    margin-left: 2rem;
    height: 17.5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 1.2rem 0;
    .topic_title {
      display: flex;
      align-items: center;
      font-size: 1.6rem;
      color: #000000;
      font-weight: bold;
      .topic_tag {
        width: 39px;
        height: 17px;
        margin-right: 1rem;
        margin-top: 2px;
      }
    }
    .topic_intro {
      margin-top: 1.5rem;
      font-size: 1.4rem;
      line-height: 1.7;
      color: #666666;
      word-break: break-all;
    }
    .topic_time {
      display: flex;
      align-items: center;
      color: #000000;
      font-size: 1.4rem;
      .topic_time_item {
        display: flex;
        align-items: center;
        margin-right: 3rem;
        .topic_time_icon {
          width: 16px;
          height: 16px;
          margin-right: 0.8rem;
          margin-top: 1px;
        }
      }
    }
  }
}
.tool_bar {
  padding-left: 0.8rem;
  display: flex;
  align-items: center;
  .count_text {
    margin-right: 2.7rem;
  }
  .search {
    width: 28rem;
    margin-right: 1.5rem;
    .search_input {
      /deep/ .el-input__inner {
        background: #ffffff;
        border: none;
      }
    }
  }
}
.loading_list {
  margin-top: 2.5rem;
}
.main_list {
  min-height: 40rem;
  margin-top: 2.5rem;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: repeat(auto-fill, 15.6rem);
  grid-gap: 2.5rem;
  .course_item {
    text-decoration: none;
    border: solid 2px #ffffff;
    overflow: hidden;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
    }
    height: 11.4rem;
    background: #ffffff;
    border-radius: 0.4rem;
    padding: 1.9rem;
    display: flex;
    user-select: none;
    .course_cover_wrap {
      width: 20.4rem;
      border-radius: 0.4rem;
      position: relative;
      overflow: hidden;
      .course_tag {
        display: none;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      .course_cover {
        width: 100%;
        height: 100%;
      }
    }
    .course_info {
      flex: 1;
      margin-left: 1.5rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 0.5rem 0;
      overflow: hidden;
      .course_title {
        font-size: 1.6rem;
        font-weight: bold;
        color: #000000;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .course_intro {
        color: #666666;
        font-size: 1.4rem;
        .course_type {
          margin-bottom: 1rem;
          white-space: nowrap;
        }
      }
    }
  }
  .course_item:hover,
  .course_item:active {
    border: solid 2px #00a2e9;
    box-shadow: 0 0.4rem 2rem 0 rgba(31, 31, 31, 0.1);
    .course_title {
      color: #00a2e9;
    }
  }
}
.page_nav {
  display: table;
  margin: 2rem auto;
}
/deep/ .el-input__inner {
  height: 4rem;
  line-height: 4rem;
  font-size: 1.4rem;
}
/deep/ .el-input__icon {
  font-size: 1.6rem !important;
  line-height: 4rem;
}
.el-button {
  padding: 1.2rem 2rem;
  font-size: 1.4rem;
}
/deep/ .el-select-dropdown__item {
  font-size: 1.4rem;
  height: 3.4rem;
  line-height: 3.4rem;
  padding: 0 2rem;
}
</style>